import { render } from "./MaterialSearchForm.vue?vue&type=template&id=4889d36c&scoped=true"
import script from "./MaterialSearchForm.vue?vue&type=script&lang=js"
export * from "./MaterialSearchForm.vue?vue&type=script&lang=js"

import "./MaterialSearchForm.vue?vue&type=style&index=0&id=4889d36c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4889d36c"]])

export default __exports__